import { render } from "./OverviewSectionCard.vue?vue&type=template&id=4ffa0abb&scoped=true"
import script from "./OverviewSectionCard.vue?vue&type=script&lang=js"
export * from "./OverviewSectionCard.vue?vue&type=script&lang=js"

import "./OverviewSectionCard.vue?vue&type=style&index=0&id=4ffa0abb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffa0abb"]])

export default __exports__